export const avatarType = {
  SQUARE: 'SQUARE',
  CIRCLE: 'CIRCLE',
};
